module.exports = __webpack_public_path__ + "static/media/danish-red.93600d20.svg";